<template lang="pug">
  #Profile
    .text-center.mb-5(
      v-if="data"
    )
      .p-3
        .mb-2.mt-3
          ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-gray(
            :profileUrl="profileImgUrl",
            :style="{ 'width': '120px', 'height': '120px' }",
            :changeProfile="true",
            @changeProfileImgHandler="changeProfileImgHandler"
          )
          input.d-none(
            type="file",
            accept="image/*",
            id="imageUpload",
            @change="fileUploadHandler()",
            ref="imageUploadInput"
          )
        p.mb-2 {{ data.chinese_last_name }} {{ data.chinese_first_name }}
      hr.border-primary.border-width-lg.w-100
      .p-3
        p.mb-2
          i.fas.fa-map-marker-alt.mr-2
          span 店舖：{{ data.stores[0].store_dealer_title }}/{{ data.stores[0].title }}
        p.mb-0
          i.fas.fa-user.mr-2
          span 客戶人數：{{ data.member_count }}位
      .workTimeArea.mx-3.position-relative
        .upper.position-relative
          .py-3.d-flex.align-items-center.justify-content-center
            span(v-if="!edit_auto_reply_mode") 休假自動回覆：{{ is_auto_reply ? '開啟' : '關閉'}}
            // 編輯休假自動回覆模式
            span.mr-3(v-else) 休假自動回覆：{{ is_auto_reply_tmp ? '開啟' : '關閉'}}
            i.fas.fa-toggle-on(style="font-size: 1.5rem" v-if="is_auto_reply_tmp && edit_auto_reply_mode" @click="is_auto_reply_tmp = !is_auto_reply_tmp")
            i.fas.fa-toggle-off(style="font-size: 1.5rem" v-if="!is_auto_reply_tmp && edit_auto_reply_mode" @click="is_auto_reply_tmp = !is_auto_reply_tmp")
          .position-absolute(style='top:50%; right: 0; transform: translate(-50%, -50%);')
            i.fas.fa-pencil-alt.circle.p-1(v-show="!edit_auto_reply_mode" @click='changeEditAutoReplyMode()')
        .lower.p-3
          p.mb-0(v-if="!edit_auto_reply_mode") {{ reply_member_msg ? reply_member_msg : '未設定休假自動回覆' }}
          // 編輯休假自動回覆模式
          b-form-textarea.mb-3(v-else rows="5", type="textarea" v-model='reply_member_msg_tmp')
          span(v-if="edit_auto_reply_mode") 字數 {{ reply_member_msg_tmp ? reply_member_msg_tmp.length : 0}} / 100
      .buttonArea.mt-3.pb-5(v-if="edit_auto_reply_mode")
        .mx-5.no-gutters
          b-button.col-4.mx-2(
            variant="primary",
            @click="changeEditAutoReplyMode()"
            class="rounded-25 text-black border-gray"
          ) 取消
          b-button.col-4.mx-2(
            variant="primary",
            @click="saveAutoReplyHandler()"
            class="rounded-25 text-black border-gray"
          ) 儲存設定

</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

const _ = require('lodash');

export default {
  name: 'ProfileIndex',
  components: {
    ProfilePhotoSticker
  },
  data() {
    return {
      is_auto_reply: false,
      is_auto_reply_tmp: false,
      reply_member_msg: '',
      reply_member_msg_tmp: '',
      edit_auto_reply_mode: false
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    // 取得個人資料
    vm.$store.dispatch('sa_profile/getProfileHandler')
      .then(() => {
        vm.reply_member_msg = vm.data.reply_member_msg;
        vm.is_auto_reply = vm.data.is_work !== 1;
        vm.$swal.close();
        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    changeProfileImgHandler() {
      this.$refs.imageUploadInput.click();
    },
    fileUploadHandler() {
      const vm = this;
      const obj = vm.$refs.imageUploadInput;
      if (!obj.files[0]) return;

      vm.$swal.fire({
        title: '上傳中',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      const file = obj.files[0];
      const formData = new FormData();
      formData.append('file', file);

      vm.$store.dispatch('sa_profile/changeProfilePictureHandler', formData)
        .then(() => {
          obj.value = null;
          vm.$swal.close();
          vm.$snotify.success(null, '更換成功');
        });
    },
    changeEditAutoReplyMode() {
      const vm = this;
      vm.edit_auto_reply_mode = !vm.edit_auto_reply_mode;
      vm.is_auto_reply_tmp = vm.is_auto_reply;
      vm.reply_member_msg_tmp = _.cloneDeep(vm.reply_member_msg);
    },
    saveAutoReplyHandler() {
      const vm = this;
      const data = {
        is_work: !vm.is_auto_reply_tmp,
        reply_member_msg: vm.reply_member_msg_tmp
      };
      if (vm.is_auto_reply_tmp ) {
        if (!vm.reply_member_msg_tmp) {
          vm.$swal.fire({
            icon: 'error',
            title: '請填寫休假自動回覆'
          });
          return;
        }
        if (vm.reply_member_msg_tmp && vm.reply_member_msg_tmp.length > 100) {
          vm.$swal.fire({
            icon: 'error',
            title: '休假自動回覆超過100字'
          });
        }
      }

      vm.$swal.fire({
        title: '資料送出中',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_profile/saveAutoReplyHandler', data).then(() => {
        vm.$swal.close();
        vm.reply_member_msg = vm.reply_member_msg_tmp;
        vm.is_auto_reply = vm.is_auto_reply_tmp;
        vm.changeEditAutoReplyMode();
      });
    }
  },
  computed: {
    ...mapState({
      data: (state) => state.sa_profile.data,
      profileImgUrl: (state) => state.sa_profile.profileImgUrl
    })
  }
};
</script>

<style lang="scss" scoped>
  .workTimeArea {
    background-color: var(--primary);
    border-radius: 5px;
    .upper {
      border-bottom: 1px solid #fff;
      .circle {
        border: 1px solid #000;
        border-radius: 100%;
      }
    }
  }
</style>
